// connectIntercomWithUserId.js
'use strict';
import getMeData from '../selector/getMeData.js';
import mergeMeData from '../action/mergeMeData.js';
import { getUserPicture, MediaAssetFormat } from '../resource/getMediaAsset.js';

/**
 * Connect Intercom With User Id.
 * @kind action
 * @param {object} {intercomUserHash} - user_hash from pusher event data.
 * @return {Promise} Action promise.
 */
const connectIntercomWithUserId =
  ({ intercomUserHash }) =>
  async (dispatch, getState) => {
    const userId = getMeData(getState(), 'id');

    if (!intercomUserHash || !userId) {
      return { type: '' };
    }

    const updateIntercom = () =>
      window.Intercom('update', {
        user_hash: intercomUserHash,
        user_id: userId,
        avatar: {
          type: 'avatar',
          image_url: getUserPicture({
            userId,
            meId: userId,
            size: 128,
            format: MediaAssetFormat.JPG,
          }).href,
        },
      });

    if (window.Intercom) {
      updateIntercom();
    } else {
      window.intercomLoadedCallbacks.push(updateIntercom);
    }

    return dispatch(
      mergeMeData({
        field: 'intercomUserHash',
        value: intercomUserHash,
      })
    );
  };

export default connectIntercomWithUserId;
